// app/javascript/controllers/scroll_controller.js
//
// Usage Examples:
//
// Basic usage - scroll to element with id "today":
// <div data-controller="scroll" data-scroll-target-id-value="today">
//   <div class="card" id="some-date">...</div>
//   <div class="card" id="today">...</div>
//   <div class="card" id="another-date">...</div>
// </div>
//
// With custom scroll options:
// <div data-controller="scroll"
//      data-scroll-target-id-value="today"
//      data-scroll-behavior-value="instant"
//      data-scroll-block-value="start">
//   <!-- Your cards -->
// </div>
//
// Scroll to any specific ID:
// <div data-controller="scroll" data-scroll-target-id-value="2024-03-15">
//   <!-- Your cards -->
// </div>

import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    targetId: String,
    behavior: { type: String, default: 'smooth' },
    block: { type: String, default: 'center' },
    inline: { type: String, default: 'nearest' },
  }

  connect() {
    if (this.targetIdValue) {
      this.scrollToElement()
    }
  }

  scrollToElement() {
    const targetElement = document.getElementById(this.targetIdValue)

    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: this.behaviorValue,
        block: this.blockValue,
        inline: this.inlineValue,
      })
    }
  }

  // Optional: method to scroll to a different element programmatically
  scrollTo(event) {
    const targetId = event.params.id || event.currentTarget.dataset.scrollId
    if (targetId) {
      const element = document.getElementById(targetId)
      if (element) {
        element.scrollIntoView({
          behavior: this.behaviorValue,
          block: this.blockValue,
          inline: this.inlineValue,
        })
      }
    }
  }
}
